import { BusinessCategoryAttributes } from "../attributes/business-category-attributes";

class BusinessCategory {
  id: number;
  code: string;
  designation: string;

  constructor(id: number, code: string, designation: string) {
    this.id = id;
    this.code = code;
    this.designation = designation;
  }

  static fromJson(json: BusinessCategoryAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new BusinessCategory(json.id, json.code, json.designation);
  }
}

export default BusinessCategory;
